/*
 * @Author: sail web admin
 * @Date: 2020-05-07 10:18:45
 * @Last Modified by: sail web admin
 * @Last Modified time: 2020-05-07 11:27:30
 * 登录模块英文
 */
export default {
  Login: 'Log in',
  AdministratorLogin: 'Administrator login',
  MobileNumber: ' mobile number',
  SMSVerificationCode: ' the code',
  GetCode: 'Get code',
  Resend: 's to resend'
};
